"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toPayload = exports.toError = void 0;
const toPayload = (id, result) => {
  return {
    jsonrpc: '2.0',
    id,
    result
  };
};
exports.toPayload = toPayload;
const toError = (id, msg, code) => {
  return {
    jsonrpc: '2.0',
    id,
    error: {
      code: code ? code : -32603,
      message: msg
    }
  };
};
exports.toError = toError;